<template>
  <div>
    <kst-output field="StockTrfNumber" :data="data" :catalog="Catalog"/>
    <kst-output field="Date" :data="data" :catalog="Catalog"/>
    <kst-output field="SourceWarehouseID" :data="data" :catalog="Catalog"/>
    <kst-output field="DestinationWarehouseID" :data="data" :catalog="Catalog"/>
    <kst-output field="Comment" :data="data" :catalog="Catalog"/>

    <kst-output control-off field="CreatedBy" :data="data" :catalog="Catalog">
      <template #default>
        <kst-output expanded floating-label
          class="pr-2"
          field="CreatedByID" :data="data" :catalog="Catalog"
        />
      </template>
      <template #right>
        <kst-output addons expanded floating-label
          field="CreatedDate" :data="data" :catalog="Catalog"
        />
      </template>
    </kst-output>
  </div>
</template>

<script>
import Catalog from "../StockTrfCatalog.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>